import { render, staticRenderFns } from "./TcmHome.vue?vue&type=template&id=bdd50fa2&scoped=true&"
import script from "./TcmHome.vue?vue&type=script&lang=js&"
export * from "./TcmHome.vue?vue&type=script&lang=js&"
import style0 from "./TcmHome.vue?vue&type=style&index=0&id=bdd50fa2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd50fa2",
  null
  
)

export default component.exports